import * as actions from '../actions/history'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
	history: [],
	lastReceivedMonth: null,
	lastReceivedYear: null,
	lastReceivedCount: null,

	filter: {
		month: '',
		monthError: '',
		year: '',
		yearError: ''
	}
})

export default function (state = initialState, action){
	switch(action.type){
		case actions.HISTORY_UPDATE_HISTORY:
			return state
				.set('history', action.concat ? state.history.concat(action.history) : action.history)
				.set('lastReceivedMonth', action.month)
				.set('lastReceivedYear', action.year)
				.set('lastReceivedCount', action.history.length)

		case actions.HISTORY_CLEAR_HISTORY_FILTER:
			return state.set('filter', {month: '', year: ''})

		case actions.HISTORY_STORE_FILTER_VALUE:
			return state.setIn(['filter', action.field], action.value)

		case actions.HISTORY_VALIDATE_FILTER_STEP:
			const newState = {month: state.filter.month, year: state.filter.year}
			for(let key in action.validation){
				newState[key+'Error'] = action.validation[key].shift()
			}
			return state.setIn(['filter'], newState)

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/history.js